/** Dot-paths must match backend evaluator + AttioValuationDetailResponse shape. */
export const ASSIGNMENT_CONDITION_FIELD_OPTIONS: { value: string; label: string }[] = [
  { value: 'valuedInformation.valuationLeadName', label: 'Valuation lead' },
  { value: 'valuedInformation.valuationEngagementManager', label: 'Engagement manager' },

];

export const ASSIGNMENT_CONDITION_OPERATORS: { value: string; label: string }[] = [
  { value: 'equals', label: 'equals' },
  { value: 'not_equals', label: 'does not equal' }
];
